var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3595 11.4992L12.2926 5.86561L12.973 5.13281L19.973 11.6328L20.3676 11.9992L19.973 12.3656L12.973 18.8656L12.2926 18.1328L18.3595 12.4992L3.63281 12.4992V11.4992L18.3595 11.4992Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/arrow_short.9c17beb7.svg";
export { SvgComponent as ReactComponent };